import ImageGallery from '../../../../src/03-composites/ImageGallery';
import React from 'react';
export default {
  ImageGallery,
  React
};